interface UseSaleManagementProps {
  sampleData: any[];
  setSampleData: (data: any[]) => void;
  selectedItem: any;
  onClose: () => void;
  isCredit?: boolean;
}

export const useSaleManagement = ({
  sampleData,
  setSampleData,
  selectedItem,
  onClose,
  isCredit
}: UseSaleManagementProps) => {
  const handleSaleConfirm = (quantity: number) => {
    if (!selectedItem) return;

    const updatedData = sampleData.map(item => {
      if (item.id === selectedItem.id) {
        return {
          ...item,
          quantity: item.quantity - quantity
        };
      }
      return item;
    });

    setSampleData(updatedData);
    onClose();
  };

  return { handleSaleConfirm };
};